import { useCallback, useState } from 'react'


type InputTypes = string | number | undefined

type Params = {
    initialValue: InputTypes
    options?: {
        onBlur?: (value: InputTypes) => InputTypes
        allowOnlyNumbers?: boolean
    }
}

export function useInputValue(params: Params) {

    const [value, setValue] = useState(params.initialValue)

    const onChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            let incomingValue = e.target.value

            if (params.options?.allowOnlyNumbers === true) {
                incomingValue = incomingValue.replace(/[^0-9]/g, '')
            }

            setValue(incomingValue)
        }, [params.options]
    )

    const onBlur = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const trimmedValue = e.target.value.trim()

        if (params.options?.onBlur) {

            const value = params.options.onBlur(trimmedValue)
            setValue(value)

        } else if (trimmedValue === "") {
            setValue(params.initialValue)
        }

    }, [params.initialValue, params.options])

    const setInputManually = useCallback((value: string) => {
        setValue(value)
    }, [])

    return {
        value,
        onChange,
        onBlur,
        setInputManually
    }

}


